<div class="container" >
  <mat-card class="mb-3" >
    <tr>
      <td>
        <p style="text-decoration: underline;" >{{ location_url + comment_data.blog_url }}</p>
      </td>
      
    </tr>
    <tr>
      <td >
        <a class="pl-5" >
          <button  (click)="showSnackBar('Copied to clipboard !!!','OK')"   ngxClipboard [cbContent]="location_url + comment_data.blog_url"  style="background-color: bisque;" mat-raised-button>
            <mat-icon>
              content_copy
            </mat-icon>
            copy
          </button>
        </a>
        <a target="_blank" [routerLink]="['/blog', profile_url , blog_url ]"    >
          <button style="background-color: bisque;" mat-raised-button>
            <mat-icon>
              visibility
            </mat-icon>
            view
          </button>
        </a>
      </td>
    </tr>
  </mat-card>


  <mat-divider class="mb-3" ></mat-divider>

  <mat-accordion *ngFor="let note of postList; let i = index" >
    <form [formGroup]="noteListFormControls[i]" >
      <mat-expansion-panel hideToggle>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <div class="mr-2" >

            </div>
          </mat-panel-title>
          <mat-panel-description>
            <tr>
              <td>
                <h1>{{note.title}}</h1>
                <button class="ml-5" (click)="changeEditable(i)" mat-raised-button style="background-color:whitesmoke" >
                  <mat-icon>edit</mat-icon>
                  Edit POST
              </button>
              </td>

            </tr>


          </mat-panel-description>
        </mat-expansion-panel-header>

        <hr>
        <div *ngIf="noteListEditor[i]" >
          <mat-form-field class="example-full-width">
            <mat-label>Title</mat-label>
            <input matInput  formControlName="title" value="Sushi">
          </mat-form-field>
        </div>
        <tr *ngIf="noteListEditor[i]" >
          <td>
            <mat-form-field class="example-full-width">
              <mat-label>Youtube Id</mat-label>
              <input matInput  formControlName="youtube_id" value="Sushi">
            </mat-form-field>
          </td>
          <td class="pl-5" >
            <mat-form-field class="example-full-width">
              <mat-label>Position</mat-label>
              <input matInput type="number" formControlName="position" value="Sushi">
            </mat-form-field>
          </td>
        </tr>
        <quill-editor *ngIf="noteListEditor[i]" [styles]="{height: '535px'}"  formControlName="inner_html" ></quill-editor>
        <tr *ngIf="!noteListEditor[i]"  >
          <div class=" ql-snow" style="border-width: 0;">
            <div class="ql-editor" [innerHTML]="note.inner_html | safeHtml" ></div>
          </div>
        </tr>
        <mat-action-row *ngIf="noteListEditor[i]">
          <button mat-flat-button color="warn" (click)="deleteNote(note.id)">DELETE</button>
          <button mat-flat-button color="primary" (click)="updateNote(i,note.id)">UPDATE</button>
        </mat-action-row>
      </mat-expansion-panel>
    </form>

  </mat-accordion>
  <form [formGroup]="editorForm" (ngSubmit)="onSubmit()" >
  <hr>
  <h1>Add new POST here</h1>
  <mat-form-field class="example-full-width">
    <mat-label>Title</mat-label>
    <input matInput  formControlName="title" value="Sushi">
  </mat-form-field>

  <tr >

    <td>
      <mat-form-field class="example-full-width">
        <mat-label>Youtube ID</mat-label>
        <input matInput  formControlName="youtube_id" value="Sushi">
      </mat-form-field>
    </td>
    <td class="pl-5" >
      <mat-form-field class="example-full-width">
        <mat-label>Position</mat-label>
        <input matInput type="number" formControlName="position" value="Sushi">
      </mat-form-field>
    </td>
  </tr>


  <quill-editor  [styles]="{height: '235px'}"    formControlName="inner_html" ></quill-editor>
  <button class="mt-2" mat-flat-button color="primary">view post</button>

  <div class=" ql-snow" style="border-width: 0;">
    <div class="ql-editor" [innerHTML]='innerHtml  | safeHtml' ></div>
  </div>

</form>
<button class="mb-5" mat-raised-button color="secondary" (click)="createNote()" >
  <mat-icon>
    add
  </mat-icon>
  CREATE NOTE
</button>

</div>
